import pinyin from 'js-pinyin'
import { USERBGCOLOR } from '../help/contants'
export default {
  methods: {
    getBgColor (name) {
      if (!name) return ''
      const key = pinyin.getFullChars(name).toLowerCase().slice(0, 1)
      return USERBGCOLOR[key]
    },
    getNameTag (name) {
      if (!name) return ''
      const str = name.trim()
      return str.slice(str.length -2, str.length)
    }
  }
}